export interface KpiIndicator {
  label: string
  value: string
}

export interface AdditionalCondition {
  label: string
  value: string
}

export enum CircuitType {
  NORMAL = 'normal',
  COMISIONES = 'comisiones'
}

export interface Circuit {
  id: string
  slug: string
  title: string
  type?: CircuitType
  description: string | null
  initial_date: Date
  final_date: Date
  kpis: KpiIndicator[]
  points: number
  image: string
  category: string
  user_type: string
  infografia: string
  component: string
  points_name: string
  principal_condition: string
  additional_conditions: AdditionalCondition[]
}

export interface CircuitResumeExternal {
  points: string
  points_name: string
  percentage: string
}

export interface CircuitResume {
  points: number
  points_name: string
  percentage: number
}
